export const parseFollowUpDelays = (value) => {
  if (value === null || value === undefined) return [];

  const raw = String(value).trim();
  if (raw === '') return [];

  const delays = raw.split(',').map((part) => {
    const trimmed = part.trim();
    if (!/^\d+$/.test(trimmed))
      throw new Error(`"${trimmed}" is not a positive whole number of minutes`);

    const minutes = Number(trimmed);
    if (minutes <= 0) throw new Error('Delays must be greater than zero');

    return minutes;
  });

  if (new Set(delays).size !== delays.length)
    throw new Error('Delays must be unique');

  return delays.sort((a, b) => a - b);
};

export const formatFollowUpDelays = (delays) =>
  Array.isArray(delays) ? delays.join(',') : '';
